import React from "react";
import { isMobileOnly } from "react-device-detect";
import { FocusModeSidebarContent, FocusModeSidebarContentType } from "@lifeat/shared/system/AppModeTypes";
import { AppearanceContextType, useAppearanceContext } from "@contexts/AppearanceContext";
import TabClosedDark from "@icons/Sidebar/SidebarTab-Closed-Dark.svg";
import TabClosedLight from "@icons/Sidebar/SidebarTab-Closed-Light.svg";
import TabOpenDark from "@icons/Sidebar/SidebarTab-Open-Dark.svg";
import TabOpenLight from "@icons/Sidebar/SidebarTab-Open-Light.svg";
import CalendarSidebar from "../../../calendar/components/CalendarSidebar";
import { AppsSidebar } from "../../../widget-workspace/components/Widget/AppsWidget/AppsSidebar";
import { SoundboardSidebar } from "../../../widget-workspace/components/Widget/SoundboardWidget/SoundboardSidebar";
import SpaceSelectionContent from "./SpaceSelectionContent";
import "./SpacesSidebar.scss";

interface SpacesSidebarProps {
    readonly sidebarOpen: boolean;
    readonly toggleSidebarOpen: () => void;
    readonly sidebarContent: FocusModeSidebarContentType;
}
export default function SpacesSidebar(props: SpacesSidebarProps) {
    const { lightMode, isFocusModeActive }: AppearanceContextType = useAppearanceContext();

    const SpacesSidebarContent = (
        <div
            className={`spaces-sidebar-content ${lightMode ? "light" : "dark"} ${
                props.sidebarContent === FocusModeSidebarContent.Spaces ? "" : "hide"
            }`}
        >
            <SpaceSelectionContent />
        </div>
    );

    const CalendarSidebarContent = (
        <CalendarSidebar
            show={props.sidebarContent === FocusModeSidebarContent.Calendar}
            amplitudeEventSource="focus-mode"
            sendCalendarNotifications={!window.todesktop}
        />
    );

    let tabSvg: React.ReactNode;
    if (props.sidebarOpen) {
        tabSvg = lightMode ? <TabOpenLight /> : <TabOpenDark />;
    } else {
        tabSvg = lightMode ? <TabClosedLight /> : <TabClosedDark />;
    }

    return (
        <div
            className={`spaces-sidebar-wrapper ${isMobileOnly ? "" : "left-sidebar"} ${isFocusModeActive ? "focus-mode" : ""} ${
                props.sidebarOpen ? "" : "closed"
            }`}
        >
            {props.sidebarOpen && (
                <span className={`sidebar-tab`} onClick={props.toggleSidebarOpen}>
                    {tabSvg}
                </span>
            )}

            {/* The interactive parts of the sidebar, including the entire "tray" part */}
            <div className={"sidebar-main-content-wrapper"}>
                {SpacesSidebarContent}
                {CalendarSidebarContent}
                <SoundboardSidebar show={props.sidebarContent === "soundboard"} />
                <AppsSidebar show={props.sidebarContent === "apps"} />
            </div>
        </div>
    );
}
